
/** Получает IRI из выбранного элемента или undefined. Входной параметр может быть
 * строкой (сам iri), JSON объектом с value, iri, IRI, object.value
*/
export const getSelectedIRI = selected => {
  if (!selected) return undefined;

  if (typeof selected === "string") {
    const iri = selected.trim();
    return iri || undefined;
  }

  if (selected.value && typeof selected.value === "string") {
    const iri = selected.value.trim();
    return iri || undefined;
  }

  if (selected.iri && typeof selected.iri === "string") {
    const iri = selected.iri.trim();
    return iri || undefined;
  }

  if (selected.IRI && typeof selected.IRI === "string") {
    const iri = selected.IRI.trim();
    return iri || undefined;
  }

  if (selected.object && typeof selected.object.value === "string") {
    const iri = selected.object.value.trim();
    return iri || undefined;
  }

  return undefined;
};